<template>
  <div
    ref="kt_modal_produtos_consultar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_produtos_consultar"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-body p-0">
          <ConsultarProduto
            ref="ConsultarProduto"
            :modal="true"
            @selecionarProduto="selecionarProduto"
            @fecharProduto="modalConsultarProduto"
            @adicionarProduto="adicionarProduto"
            @editarProduto="editarProduto"
          ></ConsultarProduto>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="exibirEditarProduto"
    ref="kt_modal_produtos_editar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_produtos_editar"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" v-if="this.idProduto === 0">
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Adicionar Produto
          </h3>
          <h3 class="modal-title" v-else>
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Editar Produto
          </h3>
          <div
            class="btn btn-sm btn-light"
            data-bs-dismiss="modal"
            @click="modalEditarProduto(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/arrows/arr079.svg" />
            </span>
            Voltar
          </div>
        </div>
        <div class="modal-body p-0">
          <EditarProduto
            :modal="true"
            @cancelarProduto="modalEditarProduto"
            @confirmarProduto="confirmarProduto"
            :idProduto="idProduto"
          ></EditarProduto>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConsultarProduto from "@/views/produtos/Consultar.vue";
import EditarProduto from "@/views/produtos/Editar.vue";
import { defineComponent } from "vue";

import {
  hideModal,
  hideModalId,
  getOrCreateInstanceModal,
  showModal,
} from "@/core/helpers/dom";

export default defineComponent({
  name: "ProdutosModal",
  emits: ["selecionarProduto", "exibirModalProdutos"],
  components: {
    ConsultarProduto,
    EditarProduto,
  },
  methods: {
    modalConsultarProduto(exibir) {
      if (exibir === false) {
        this.$emit("exibirModalProdutos", false);
      }
    },
    selecionarProduto(produto) {
      this.$emit("selecionarProduto", produto);
      this.modalConsultarProduto(false);
      hideModal(this.$refs.kt_modal_produtos_consultar);
    },
    adicionarProduto() {
      this.idProduto = 0;
      this.modalEditarProduto(true);
    },
    editarProduto(id) {
      this.idProduto = id;
      this.modalEditarProduto(true);
    },
    modalEditarProduto(exibir) {
      this.exibirEditarProduto = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_produtos_editar",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_produtos_editar");
          },
          /*close*/ () => {
            this.modalEditarProduto(false);
          }
        );
      }
    },
    confirmarProduto() {
      this.modalEditarProduto(false);
      hideModal(this.$refs.kt_modal_produtos_editar);
      this.$refs.ConsultarProduto.loadData();
    },
  },
  data() {
    return {
      idProduto: 0,
      exibirEditarProduto: false,
    };
  },
});
</script>

<style></style>
